<div mat-dialog-title class="title">
  <title mat-dialog-title [title]="data.camera.name + ' ' + ('cameras.aiRules.title' | t)">
    {{ data.camera.name }} {{ 'cameras.aiRules.title' | t }}
  </title>
  <div class="legend">
    <sn-icon-button (click)="toggleLegend()">
      <sn-icon>info</sn-icon>
    </sn-icon-button>
    <div class="legendPanel" *ngIf="this.isLegendOpen">
      <div class="rule-explanation">
        <div class="greenCircle"></div>
        <strong>-></strong>
        <div class="redCircle"></div>
        <span>{{ 'cameras.aiRules.legend.wrongDirection' | t }}</span>
      </div>
      <hr />
      <div class="rule-explanation">
        <div class="redCircle"></div>
        <strong>-></strong>
        <div class="greenCircle"></div>
        <span>{{ 'cameras.aiRules.legend.correctDirection' | t }}</span>
      </div>
    </div>
  </div>
</div>
<mat-dialog-content>
  <div class="topSection">
    <div class="rulesContainer" *ngIf="data.camera.aiDetectionTypes[0].meta?.rules">
      <mat-list *ngFor="let rule of data.camera.aiDetectionTypes[0].meta?.rules">
        <mat-list-item class="ruleContainer">
          <div>
            <div matListItemTitle>{{ rule.name }}</div>
            <div matListItemLine class="ruleType">{{ rule.type }}</div>
            <ng-container *ngFor="let label of rule.labels">
              <span class="labels">{{ this.capitalizeLabel(label) }}</span>
            </ng-container>
          </div>
          <div class="actions">
            <div class="colorCircle" [ngStyle]="{ 'background-color': rule.color }"></div>
            <button
              mat-icon-button
              *ngIf="this.isShapeVisible.includes(rule.name)"
              color="accent"
              (click)="toggleShape(rule)"
            >
              <sn-icon fontIcon="fa-eye" fontSet="far"></sn-icon>
            </button>
            <button
              mat-icon-button
              *ngIf="!this.isShapeVisible.includes(rule.name)"
              (click)="toggleShape(rule)"
            >
              <sn-icon fontIcon="fa-eye-slash" fontSet="far"></sn-icon>
            </button>
            <button mat-icon-button (click)="editRule(rule)">
              <sn-icon fontIcon="fa-pen" fontSet="far"></sn-icon>
            </button>
            <button mat-icon-button *ngIf="this.canDelete" (click)="deleteRule(rule)">
              <sn-icon fontIcon="fa-trash-alt" fontSet="far"></sn-icon>
            </button>
          </div>
        </mat-list-item>
      </mat-list>
    </div>
    <div *ngIf="!data.camera.aiDetectionTypes[0].meta?.rules">{{ 'cameras.aiRules.noRulesCreated' | t }}</div>
    <button
      mat-button
      class="addNewRuleButton"
      color="success"
      (click)="addNewRule()"
      [disabled]="data.camera.aiDetectionTypes[0].meta?.rules?.length >= 5"
    >
      {{ 'cameras.aiRules.addNewRule' | t }}
    </button>
  </div>
  <div class="outsideContainer">
    <div class="insideContainer">
      <sn-audit-camera-stream-view
        class="subStream"
        [camera]="data.camera"
        [autoplay]="true"
        [controls]="false"
        [timestamp]="false"
        [actions]="false"
        (stateChange)="onStateChange($event)"
      >
      </sn-audit-camera-stream-view>
      <svg
        id="aiGridCanvas"
        xmlns="http://www.w3.org/2000/svg"
        class="coveringCanvas"
        [attr.height]="svgHeight"
        [attr.width]="svgWidth"
        (mouseup)="handleMouseUp($event)"
        (mousemove)="handleMouseMove($event)"
      >
        <defs>
          <pattern
            *ngIf="gridX && gridY"
            id="grid"
            [attr.width]="gridX"
            [attr.height]="gridY"
            patternUnits="userSpaceOnUse"
          >
            <path d="M 10 0 L 0 0 0 10" fill="none" stroke="white" stroke-width="1" />
          </pattern>
        </defs>
        <rect id="gridRect" width="100%" height="100%" fill="url(#grid)" />
      </svg>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="danger" mat-dialog-close>{{ 'common.close' | t }}</button>
  <button mat-button color="success" (click)="updateCameraSettings()">{{ 'common.save' | t }}</button>
</mat-dialog-actions>